class PD_Algolia_Search {
  constructor() {
    (this.i = [
      "https://cdnjs.cloudflare.com/ajax/libs/algoliasearch/4.24.0/algoliasearch-lite.umd.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/instantsearch.js/4.72.2/instantsearch.production.min.js",
    ]),
      (this.t = {}),
      (this.h = !1),
      (this.o = null),
      (this.instantsearchHelper = null),
      (this.l = null),
      (this.u = null),
      (this.g = null),
      (this.m = null),
      (this.p = null),
      (this.v = null),
      (this._ = null),
      (this.A = null),
      (this.L = null),
      (this.searchResultsEl = null);
  }
  init(i) {
    var {
      applicationId: t,
      searchKey: e,
      indexName: s,
      searchInputSelector: n,
      searchButtonSelector: h,
      widgetList: r,
      librariesToLoad: a,
      searchResultsSelector: o,
    } = i;
    return (
      (this.t = i),
      (this.l = t),
      (this.u = e),
      (this.g = s),
      (this.m = n),
      (this.p = h),
      (this.v = o),
      (this.searchResultsEl = document.querySelector(this.v)),
      this.R("Starting init."),
      this.S(),
      Array.isArray(a) &&
        (this.R("Overriding the default libraries for loading."), (this.i = a)),
      this.R("Loading required libraries..."),
      this.j()
        ? (this.R(
            "Stopping execution because we have added a library and have attached to its onload event."
          ),
          !1)
        : (this.R("No libraries to load."),
          this.R("Resetting event listeners on original elements..."),
          !1 === this.D()
            ? (this.R("Error resetting event listeners."), !1)
            : (this.R("Done."),
              this.R("Loading Algolia instance..."),
              !1 === this.N()
                ? (this.R("Error initializing Algolia."), !1)
                : (this.R("Done."),
                  this.R("Registering widgets with Algolia..."),
                  !1 === this.k(r)
                    ? (this.R("Error registering widgets."), !1)
                    : (this.o.start(),
                      this.R("Done."),
                      this.R("All done, search is ready."),
                      (this.h = !0)))))
    );
  }
  R(t, e = "info", i = !1) {
    if (window.location.search.includes("pd_search_log=true") || i) {
      let i = "[PD-AlgoliaSearch]";
      switch (e) {
        case "debug":
          i += " (DEBUG)";
          break;
        case "error":
          i += " (ERROR)";
          break;
        case "warn":
          i += " (WARN)";
          break;
        default:
          i += " (INFO)";
      }
      console.log(i, t);
    }
  }
  O() {
    return !1 === this.h && (this.R("Retrying init..."), this.init(this.t), !0);
  }
  S() {
    window.addEventListener("DOMContentLoaded", () => {
      window.pd_search.O();
    }),
      window.addEventListener("load", () => {
        window.pd_search.O();
      });
  }
  j() {
    return (
      0 <
      this.i
        .map((t) => {
          var i;
          return !(
            0 <
              Array.from(document.querySelectorAll("script")).filter(
                (i) => i.src === t
              ).length ||
            (((i = document.createElement("script")).onload = () => {
              this.R("Library loaded, attempting init again."), this.O();
            }),
            (i.defer = !0),
            (i.src = t),
            document.head.appendChild(i),
            0)
          );
        })
        .filter((i) => !0 === i).length
    );
  }
  N() {
    return (
      "function" == typeof instantsearch &&
      "function" == typeof algoliasearch &&
      ((this.o = instantsearch({
        indexName: this.g,
        searchClient: algoliasearch(this.l, this.u),
        routing: !0,
        searchFunction: function (i) {
          window.pd_search.instantsearchHelper = i;
          if (i.state.query === "") {
            window.pd_search.searchResultsEl.classList.add("hidden");
            window.pd_search.searchResultsEl.style.display = "none";
            window.scrollTo(0, 0);
            document.body.classList.remove("pd-search-open");
          } else {
            // Only set the input value if the query isn't empty
            const searchInput = document.querySelector(
              "#pd-main-searchbox-input"
            );
            if (searchInput) {
              searchInput.value = i.state.query;
            }
            window.pd_search.searchResultsEl.classList.remove("hidden");
            window.pd_search.searchResultsEl.style.display = "";
            window.scrollTo(0, 0);
            document.body.classList.add("pd-search-open");
            i.search();
          }
        },
      })),
      !0)
    );
  }
  D() {
    this._ = document.querySelector(this.m);
    this.A = document.querySelector(this.p);

    if (!this._) {
      console.error("Search input element not found");
      return false;
    }

    this._.addEventListener("input", (i) => {
      this.L = i.target.value;
    });

    if (this.A) {
      this.A.addEventListener("click", () => {
        this.F(this.L || "");
      });
    } else {
      console.warn("Search button element not found");
    }

    return true;
  }
  F(i) {
    return !(
      !this.instantsearchHelper ||
      void 0 === this.instantsearchHelper.setQuery ||
      (this.instantsearchHelper.setQuery(i), 0)
    );
  }
  k(i) {
    return (
      "function" == typeof this.o.addWidgets && (this.o.addWidgets(i()), !0)
    );
  }
  searchInputExists() {
    return !!document.querySelector(this.m);
  }
  createSearchInput() {
    const existingInput = document.querySelector(this.m);
    if (!existingInput) {
      const searchContainer = document.querySelector("#pd-main-searchbox");
      if (searchContainer) {
        const newInput = document.createElement("input");
        newInput.type = "text";
        newInput.id = this.m.replace("#", "");
        newInput.placeholder = "Search";
        searchContainer.prepend(newInput);
      }
    }
  }
}

// Initialize - docs for all parameters can be found above.
window.pd_search = new PD_Algolia_Search();
window.pd_search.init({
  applicationId: "ZG9BY4ZMZM",
  searchKey: "bd016a7377a1ab18233d76e97a64ac69",
  indexName: "shopify_products",
  searchInputSelector: "#pd-main-searchbox-input",
  searchButtonSelector: "#pd-main-searchbox-button",
  searchResultsSelector: "#pd-results",
  widgetList: () => {
    let mainSearchbox = instantsearch.connectors.connectSearchBox(function (
      renderOptions,
      isFirstRender
    ) {
      let widgetParams = renderOptions.widgetParams;

      if (isFirstRender) {
        document
          .querySelector(widgetParams.container)
          .addEventListener("input", function (event) {
            renderOptions.refine(event.target.value);
          });
      }
    });

    return [
      instantsearch.widgets.configure({
        hitsPerPage: 16,
        //filters: 'meta.custom.algolia_hide_product:false',
        optionalFilters: ["tags:-spare parts"], // Push "spare parts" to the bottom
      }),
      mainSearchbox({
        container: "#pd-main-searchbox-input",
        placeholder: "Search..",
      }),
      instantsearch.widgets.pagination({
        container: "#pd-pagination",
        showFirst: false,
        showLast: false,
        cssClasses: {
          root: "",
          list: "ais-Pagination-list pagination-custom",
          item: "ais-Pagination-item pagination-custom__num",
          selectedItem: "ais-Pagination-item--selected active",
          link: "ais-Pagination-link",
        },
      }),
      instantsearch.widgets.hits({
        container: "#pd-results",
        templates: {
          item: function item(hit) {
            return `
                            <div class="card-wrapper product-card-wrapper">   
                                <div class="ais-hit ais-product card card--standard card--media " data-handle="${
                                  hit.handle
                                }" data-algolia-objectid="${
              hit.objectID
            }" data-variant-id="${hit.objectID}" data-product-id="${
              hit.id
            }" style="--ratio-percent: 125.0%;">
                                    <div class="card__inner color-background-2 gradient ratio">
                                         <div class="card__media"> 
                                             <a data-algolia-objectid="${
                                               hit.objectID
                                             }" href="/products/${
              hit.handle
            }" title="${
              hit.title
            }" class="media media--transparent media--hover-effect" data-tester="${
              hit.product_image
            }">
                                                 <img class="ais-hit--picture" src="${
                                                   hit.product_image
                                                 }" alt="${hit.title} - ${
              hit.variant_title
            }"/>
                                             </a>
                                         </div>
                                           <div class="ais_badge card__badge bottom right" style="z-index: 1">
                                               ${
                                                 hit.price <
                                                 hit.compare_at_price
                                                   ? `<span class="badge badge--bottom-left ais-sale-badge">
                                                      <span>  ${Math.floor(
                                                        ((hit.compare_at_price -
                                                          hit.price) /
                                                          hit.compare_at_price) *
                                                          100
                                                      )}% OFF </span>
                                                    </span> `
                                                   : ``
                                               } 
                                               ${
                                                 hit.variants_inventory_count <
                                                   1 &&
                                                 hit.inventory_policy === "deny"
                                                   ? `<span class="badge ais-sold-out-badge badge--bottom-left color-inverse">Sold out</span>`
                                                   : ``
                                               }
                                         </div>
                                         
                                         <form id="algolia-add-to-cart-${
                                           hit.objectID
                                         }" style="display: none;" action="/cart/add" method="post" enctype="multipart/form-data">
            								 <input type="hidden" name="id" value="${hit.objectID}">
            							 </form>
            							 <p class="ais-hit--cart btn-state-ready stain-button-canvas group/quick-action-button bg-button flex items-center justify-center typography-accent-bold text-a3 
                                                   transition-opacity duration-[--enter-animation-duration] pointer-events-auto  w-8 aspect-square min-w-[40px]  min-h-[40px] md:min-h-[48px] 
                                                   md:px-5 md:py-3 md:w-full md:aspect-auto">
            								 <button class="ais-hit--cart-button btn-state-ready text-button-contrast group-hover/quick-action-button:text-button-contrast/50 whitespace-nowrap" 
                                                     data-form-id="algolia-add-to-cart-${
                                                       hit.objectID
                                                     }">Add to cart</button>
            							 </p>
                                    </div>
        							<div class="ais-hit--details product__grid__info text-center card__content">
                                        <a data-algolia-objectid="${
                                          hit.objectID
                                        }" href="/products/${
              hit.handle
            }" title="${hit.title}">
            								<div class="ais-hit--details card__information">
                                                <div class="product__grid__title__wrapper card__heading h3">
                                                    <p class="ais-hit--subtitle product__grid__title visually-hidden" title="${
                                                      hit.product_type
                                                    }${
              hit.vendor ? " by " + hit.vendor : ""
            }">
                										${instantsearch.highlight({
                                      attribute: "product_type",
                                      hit: hit,
                                    })}
                										${
                                      hit.vendor
                                        ? " by " +
                                          instantsearch.highlight({
                                            attribute: "vendor",
                                            hit: hit,
                                          })
                                        : ""
                                    }
                									</p>
                                                    <p class="ais-hit--title product__grid__title card__heading h3">
                										${instantsearch.highlight({ attribute: "title", hit: hit })}
                									</p>
                                                </div>
                                                
                                                <div class="product__grid__price  product__grid__price--nowrap price">
                                                    <div class="card-information">
                                                        <div class="price__container">
                                                              ${
                                                                hit.price <
                                                                hit.compare_at_price
                                                                  ? `
                                                                <div class="price  price--on-sale">
                                                                      <span class="price__container">
                                                                          <div class="price__regular show">
                                                                              <span class="price-item price-item--regular">
                                                                                  ${hit.compare_at_price.toLocaleString(
                                                                                    "en-AU",
                                                                                    {
                                                                                      style:
                                                                                        "currency",
                                                                                      currency:
                                                                                        "NZD",
                                                                                    }
                                                                                  )}   
                                                                               </span>
                                                                             </div>
                                                                          </span>
                                                                          <span class="compare-at ais-hit--price price__sale">
                                                                              
                                                                                  ${hit.price.toLocaleString(
                                                                                    "en-AU",
                                                                                    {
                                                                                      style:
                                                                                        "currency",
                                                                                      currency:
                                                                                        "NZD",
                                                                                    }
                                                                                  )} 
                                                                             
                                                                          </span>
                                                                    </div>
                                                                    `
                                                                  : `
                                                                    <span class="price ais-hit--price price__regular show">
                                                                        <span class="price-item price-item--regular">
                                                                            ${hit.price.toLocaleString(
                                                                              "en-AU",
                                                                              {
                                                                                style:
                                                                                  "currency",
                                                                                currency:
                                                                                  "NZD",
                                                                              }
                                                                            )}
                                                                        </span> 
                                                                    </span>
                                                                  `
                                                              }
                                                          </div>
                      									<p class="ais-hit--info" style="display: none;">
                      										<span class="algolia-sku">
                      											${instantsearch.highlight({ attribute: "sku", hit: hit })}
                      										</span>
                      										<span class="algolia-barcode">
                      											${instantsearch.highlight({
                                              attribute: "barcode",
                                              hit: hit,
                                            })}
                      										</span>
                      										<span class="algolia-weight">
                      											${instantsearch.highlight({
                                              attribute: "weight",
                                              hit: hit,
                                            })}
                      										</span>
                      									</p>
                                                    </div>
                                                </div>
            								</div>
                                        </a>
        							</div>
        						</div>
                            </div>`;
          },
          empty:
            '<div class="pd-empty-results">No results found matching <strong>{{query}}</strong>.</div>',
        },
        cssClasses: {
          item: "ais-Hits-item",
          list: "ais-Hits-list",
        },
      }),

      instantsearch.widgets.rangeSlider({
        container: "#pd-price",
        attribute: "price",
        tooltips: {
          format: function (rawValue) {
            return "$" + Math.round(rawValue).toLocaleString();
          },
        },
      }),

      // Product Type filter
      instantsearch.widgets.refinementList({
        container: "#pd-product_type",
        attribute: "product_type",
        limit: 5,
        showMore: false,
        searchable: false,
        searchablePlaceholder: "Search product types",
        cssClasses: {
          searchableInput: "form-control",
          searchableSubmit: "d-none",
          searchableReset: "d-none",
        },
        templates: {
          item(item, { html, components }) {
            return html`
              <label class="ais-RefinementList-label">
                <input
                  class="ais-RefinementList-checkbox"
                  type="checkbox"
                  value="${item.value}"
                  ${item.isRefined ? "checked" : ""}
                />
                <div class="icon-checkmark-wrapper">
                  <svg
                    aria-hidden="true"
                    class="icon icon-checkmark"
                    width="1.1rem"
                    height="0.7rem"
                    viewBox="0 0 11 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1"
                      stroke="currentColor"
                      stroke-width="1.75"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </div>
                <span class="ais-RefinementList-labelText">${item.label}</span>
                <span class="ais-RefinementList-count">${item.count}</span>
              </label>
            `;
          },
        },
      }),

      // Vendor filter
      instantsearch.widgets.refinementList({
        container: "#pd-brands",
        attribute: "vendor",
        limit: 5,
        showMore: false,
        searchable: false,
        searchablePlaceholder: "Search vendors",
        cssClasses: {
          searchableInput: "form-control",
          searchableSubmit: "d-none",
          searchableReset: "d-none",
        },
        templates: {
          item(item, { html, components }) {
            return html`
              <label class="ais-RefinementList-label">
                <input
                  class="ais-RefinementList-checkbox"
                  type="checkbox"
                  value="${item.value}"
                  ${item.isRefined ? "checked" : ""}
                />
                <div class="icon-checkmark-wrapper">
                  <svg
                    aria-hidden="true"
                    class="icon icon-checkmark"
                    width="1.1rem"
                    height="0.7rem"
                    viewBox="0 0 11 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1"
                      stroke="currentColor"
                      stroke-width="1.75"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </div>
                <span class="ais-RefinementList-labelText">${item.label}</span>
                <span class="ais-RefinementList-count">${item.count}</span>
              </label>
            `;
          },
        },
      }),

      instantsearch.widgets.sortBy({
        container: "#pd-sort-by",
        items: [
          { value: "shopify_products", label: "Best selling" },
          {
            value: "shopify_products_price_asc",
            label: "Price, low to high",
          },
          {
            value: "shopify_products_price_desc",
            label: "Price, high to low",
          },
        ],
        cssClasses: {
          root: "",
          select: "form-control",
        },
        label: "sort by",
      }),

      instantsearch.widgets.stats({
        container: "#pd-stats",
        templates: {
          text:
            "{{#hasNoResults}}No results{{/hasNoResults}}" +
            "{{#hasOneResult}}1 product{{/hasOneResult}}" +
            "{{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} products{{/hasManyResults}}",
        },
      }),

      instantsearch.widgets.clearRefinements({
        container: "#closeAlgolia",
        includedAttributes: [
          "query",
          "categories.lvl0",
          "categories.lvl1",
          "categories.lvl2",
          "categories.lvl3",
          "brand",
        ],
        templates: {
          resetLabel: "",
        },
        cssClasses: {
          button: ["npopup-btn-close hidden"],
        },
      }),
    ];
  },
});

// Cache common elements for reuse
const body = document.body;
const closeAlgoliaBtn = document.querySelector("#closeAlgolia");
const searchboxInput = document.querySelector("input#pd-main-searchbox-input");
const showFiltersBtn = document.querySelector("div#pd-show-filters");
const filters = document.querySelector("aside#pd-filters");
const results = document.querySelector("div#pd-results");

// Helper function to toggle visibility using CSS class
function toggleVisibility(label) {
  const wrapper = label.parentNode;
  const filter = wrapper.querySelector(".pd_filter_box");

  if (wrapper && filter) {
    wrapper.classList.toggle("open");
    filter.style.display = filter.style.display === "none" ? "block" : "none";
  }
}

// Open search functionality
const openPdSearchBtn = document.querySelector(".open_pd_search");
if (openPdSearchBtn) {
  openPdSearchBtn.addEventListener("click", function () {
    body.classList.add("pd-search-open");
  });
}

// Close search functionality
const closePdSearchBtn = document.querySelector(".close_pd_search");
if (closePdSearchBtn && closeAlgoliaBtn && searchboxInput) {
  closePdSearchBtn.addEventListener("click", function () {
    closeAlgoliaBtn.click();
    searchboxInput.value = "";
    body.classList.remove("pd-search-open");
  });
}

// Toggle individual filters
const pdFilterTitles = document.querySelectorAll(".pd_filter_title");
if (pdFilterTitles.length > 0) {
  pdFilterTitles.forEach(function (filterTitle) {
    filterTitle.addEventListener("click", function () {
      toggleVisibility(filterTitle);
    });
  });
}

// Show/hide filters panel - filters are hidden by default
document.addEventListener("DOMContentLoaded", function () {
  if (filters) {
    filters.classList.add("hidden"); // Hide filters by default
  }

  if (showFiltersBtn && filters && results) {
    const filterButtonText = showFiltersBtn.querySelector("div");
    if (filterButtonText) {
      filterButtonText.textContent = "Filter"; // Set initial text
    }

    // Toggle filters on button click
    showFiltersBtn.addEventListener("click", function () {
      const isFiltersVisible = filterButtonText.textContent === "Hide";

      filterButtonText.textContent = isFiltersVisible ? "Filter" : "Hide";
      filters.classList.toggle("hidden", isFiltersVisible);
      results.classList.toggle("full", isFiltersVisible);
    });
  }
});
